import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { SalesApp } from '../components/apps/apps/SalesApp';
export function SalesPage() {
    const context = {
        onClose: () => window.history.back(),
        workspaceId: '',
        boardId: '',
        itemId: ''
    };
    return _jsx(SalesApp, { context: context });
}
